import script from "./growth-helpdesk.vue?vue&type=script&setup=true&lang=js"
export * from "./growth-helpdesk.vue?vue&type=script&setup=true&lang=js"

import "./growth-helpdesk.vue?vue&type=style&index=0&id=14e80a15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14e80a15"]])

export default __exports__